import { useState } from 'react';
import './Alert.css';

const Alert = ({
  type = 'info',
  title,
  message,
  dismissible = true,
  onDismiss,
  icon,
  action,
  className = '',
  ...props
}) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  const alertClasses = [
    'alert',
    `alert-${type}`,
    action ? 'alert-with-action' : '',
    className
  ].filter(Boolean).join(' ');

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss && onDismiss();
  };

  return (
    <div className={alertClasses} role="alert" {...props}>
      <div className="alert-content">
        {icon && <div className="alert-icon">{icon}</div>}
        
        <div className="alert-message">
          {title && <div className="alert-title">{title}</div>}
          {message && <div className="alert-text">{message}</div>}
        </div>
        
        {action && (
          <div className="alert-action">
            {action}
          </div>
        )}
      </div>
      
      {dismissible && (
        <button 
          type="button" 
          className="alert-dismiss" 
          onClick={handleDismiss}
          aria-label="Dismiss"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
};

export default Alert;
